<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-08-23 20:18:37
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-25 16:59:03
 * @FilePath: \seller.sviptrader.com\src\views\channel\cooperation\detail\components\date\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row-align-center">
		<div class="mr-16 yx-color-text-secondary font-h6-regular">统计时间: {{ statisticsTime }}</div>
		<div class="time-select">
			<div
				class="item font-h6-regular yx-color-text-regular"
				:class="{ active: index === timeIndex }"
				@click="selectTime(index, item.value)"
				v-for="(item, index) in timeList"
				:key="index"
			>
				{{ item.label }}
			</div>
		</div>
	</div>
</template>
<script>
import { calDate, formatterDate } from '@/utils/common';
import { format, startOfDay, endOfDay } from 'date-fns';
export default {
	props: {
		timeList: {
			type: Array,
			default: _ => [
				{ value: 1, label: '昨日' },
				{ value: 7, label: '7天' },
				{ value: 15, label: '15天' },
				{ value: 30, label: '30天' },
				{ value: 90, label: '90天' },
				{ value: 180, label: '180天' },
			],
		},
		showTimeStamp: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			timeIndex: 0,
			statisticsTime: '',
		};
	},
	methods: {
		reset(index, value) {
			this.timeIndex = index;
			if (this.showTimeStamp) return this.setTimeText(value);
			this.getStatistics(value);
			let [start_time, end_time] = formatterDate(value);
			return { start_time, end_time };
		},
		setTimeText(value) {
			let { start_time, end_time } = this.getStatistics(value);
			return {
				start_time: Math.trunc(start_time / 1000),
				end_time: Math.trunc(end_time / 1000),
			};
		},
		getStatistics(value) {
			const today = new Date();
			const [start_time, end_time] = !value ? [startOfDay(today), endOfDay(today)] : calDate(value);
			const startTimeText = format(start_time, 'yyyy/MM/dd');
			const endTimeText = format(end_time, 'yyyy/MM/dd');
			this.statisticsTime = `${startTimeText}${this.timeIndex > 0 ? '-' + endTimeText : ''}`;
			return { start_time, end_time };
		},
		selectTime(index, value) {
			this.timeIndex = index;
			if (!this.showTimeStamp) {
				this.getStatistics(value);
				let [start_time, end_time] = formatterDate(value);
				this.$emit('submit', { start_time, end_time });
			} else {
				const { start_time, end_time } = this.setTimeText(value);
				this.$emit('submit', { start_time, end_time });
			}
		},
	},
};
</script>
<style lang="less" scoped>
.time-select {
	display: flex;
	align-items: center;
	border: 1px solid #eaebf0;
	border-radius: 2px;
	font-size: 14px;
	.item {
		padding: 4px 12px;
		cursor: pointer;
		&.active {
			color: @color-primary!important;
		}
		&:nth-child(n + 2) {
			border-left: 1px solid #eaebf0;
		}
	}
}
</style>
